// this file template replace material-ui/core/utils method
// when upgrade mui that will not need assign type anymore
import { useEventCallback as MuiUseEventCallback } from '@material-ui/core/utils';
export var useEventCallback = function (func) {
    return MuiUseEventCallback(func);
};
